<template>
  <b-container fluid>
    <b-row class="pb-2">
      <b-col sm="4">
        <h3>
          <b-badge variant="primary">
            Add Field User
          </b-badge>
          <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
        </h3>
      </b-col>
      <b-col sm="4" class="pb-2 pb-sm-0" order="3" order-sm="2">
        <b-button
          v-if="canSubmit()"
          block
          variant="success"
          :disabled="!canSubmit()"
          @click="addFieldUser">
          Add {{ selected[0].Name }} <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
        </b-button>
        <b-button
          v-else
          block
          disabled
          variant="success">
          Add
        </b-button>
      </b-col>
      <b-col sm="4" class="pb-2 pb-sm-0" order="2" order-sm="3">
        <b-button 
          block
          @click="$router.go(-1)">
          Back
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="pb-2">
        <strong>Select an interviewer to add</strong>
      </b-col>
    </b-row>
    <b-table
      small
      stacked="sm"
      :busy="tableWaiting"
      :items="items"
      :fields="fields"
      selectable
      select-mode="single"
      @row-selected="rowSelected">
      <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <!-- <strong>Loading...</strong> -->
      </div>
    </b-table>
  </b-container>
</template>

<script>
import { authService } from '../_services';
export default {
  data() {
    return {
      tableWaiting: false,
      waiting: false,
      selected: [],
      items: [],
      fields: [
        {
          key: 'InterviewerID', 
          label:'Interviewer ID'
        },
        {
          key: 'Name', 
          label:'Name'
        },
        {
          key: 'Role', 
          label:'Role'
        },
        {
          key: 'Cell', 
          label:'Cell'
        },
      ]
    }
  },
  created() {
    this.getCandidates()
  },
  methods: {
    getCandidates() {
      this.tableWaiting = true
      let vm = this
      authService.getFieldUserCandidates()
      .then((response) => {
        vm.items = response.data
        vm.tableWaiting = false
      })
    },
    rowSelected(items) {
      this.selected = items
    },
    canSubmit() {
      if (this.selected.length == 1) {
        return true
      }
      return false
    },
    addFieldUser() {
      this.waiting = true
      let id = this.selected[0].InterviewerID
      let vm = this
      authService.addFieldUser(id)
      .then((response) => {
        vm.getCandidates()
        vm.waiting = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/AddFieldUserPage.vue